export const CITY_TYPES = [
    {
        value: 'RURAL',
        label: 'RURAL',
    },
    {
        value: 'URBAN',
        label: 'URBAN',
    },
    {
        value: 'SEMI_URBAN',
        label: 'SEMI_URBAN',
    },
];

export default {
    CITY_TYPES,
};
